import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const HomePage = () => import('../views/HomePage')
const Case = () => import('../views/caseDetail')
const service = () => import('../views/service')
const diannengbao = () => import('../views/diannengbao')
const guangfuxia = () => import('../views/guangfuxia')
const yunweibang = () => import('../views/yunweibang')
const plan = () => import('../views/plan')
const news = () => import('../views/news')
const aboutus = () => import('../views/aboutus')
const newsDetail = () => import('../views/newsDetaul.vue')
const router = new VueRouter({
  mode: 'hash',
  base: __dirname,
  routes: [{
    path: '/',
    name: 'HomePage',
    redirect: '/index',
    component: HomePage
  },
  {
    path: '/index',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/caseDetail',
    name: 'caseDetail',
    component: Case
  },
  {
    path: '/service',
    name: 'service',
    component: service
  },
  {
    path: '/diannengbao',
    name: 'diannengbao',
    component: diannengbao
  },
  {
    path: '/guangfuxia',
    name: 'guangfuxia',
    component: guangfuxia
  },
  {
    path: '/yunweibang',
    name: 'yunweibang',
    component: yunweibang
  },
  {
    path: '/plan',
    name: 'plan',
    component: plan
  },
  {
    path: '/news',
    name: 'news',
    component: news
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: aboutus
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: newsDetail
  }
  ]
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js